import { InjectionToken } from '@angular/core';
import { DynamicIncentiveProgramRepository } from 'src/app/core/repositories/dynamic-incentive-program.repository';

export const DynamicIncentiveProgramRepositoryToken: InjectionToken<DynamicIncentiveProgramRepository> =
  new InjectionToken<DynamicIncentiveProgramRepository>(
    'Dynamic Incentive Program Injection Token',
  );
